export const CANNED_MESSAGES = [{ content: 'Be right there!' }, { content: "I'll be with you in 5 mins." }];
export const NO_PARTICIPANTS_MESSAGE = 'There are no other participants in this chat';

export const SAFETY_GUARD_BANNER_TEXT =
  'Parents and guardians may provide information in this chat. If you learn that you are communicating with a child under the age of 13, please ask them to stop using this chat.';
